import React from 'react';
import withStyles from 'components/common/wrappers/withStyles';

function Transactions({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 100 100"
      className="w-full h-full"
    >
      <g fill={color} fillRule="nonzero" stroke="none" strokeWidth="1">
        <path
          d="M79.839 62.223c0-1.106-.929-2.001-2.076-2.001H7.096l12.422-11.973c.81-.78.81-2.033 0-2.814-.81-.781-2.11-.781-2.92 0L.648 60.807c-.81.781-.81 2.034 0 2.815l15.95 15.372c.405.39.928.586 1.468.586.54 0 1.064-.195 1.469-.586.81-.78.81-2.033 0-2.814L7.113 64.207h70.683c1.114 0 2.043-.878 2.043-1.984zM79.231 15.942L63.281.586c-.81-.781-2.109-.781-2.92 0-.81.78-.81 2.033 0 2.814l12.423 11.973H2.1c-1.147 0-2.076.894-2.076 2 0 1.107.929 2.001 2.076 2.001h70.684l-12.422 11.94c-.81.782-.81 2.034 0 2.815.405.39.928.586 1.468.586.54 0 1.064-.196 1.469-.586l15.949-15.373a1.947 1.947 0 00-.017-2.814z"
          transform="translate(10 11)"
        />
      </g>
    </svg>
  );
}

Transactions.defaultProps = {
  color: 'white',
};

export default withStyles(Transactions);
